import React from 'react';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import BrandRefreshNotFound from '../SecondaryPages/BrandRefreshNotFound';

const NoMatch = () => {
  if (isBrandRefreshEnabled()) return <BrandRefreshNotFound />;
  return (
    <>
      <h1>Sorry we could not find that page</h1>
    </>
  );
};

export default NoMatch;
